import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";

export function useCreatorAccess(enabled = true) {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ["creator-access", user?.id],
    enabled: enabled && !!user,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_my_creator_access");
      if (error) throw error;
      const result = data as {
        is_pro?: boolean;
        is_admin?: boolean;
        has_premium_through_pro?: boolean;
        can_create_powerprompt?: boolean;
      } | null;
      return {
        // Billing only (which plan the member pays for). Never an authoring check.
        isPro: result?.is_pro === true,
        isAdmin: result?.is_admin === true,
        hasPremiumThroughPro: result?.has_premium_through_pro === true,
        // The server's create_programs rule: Pro, legacy Premium, grandfathered,
        // lifetime, override or admin.
        canCreatePrograms: result?.can_create_powerprompt === true,
      };
    },
  });
  return {
    ...query,
    canAuthor: query.data?.canCreatePrograms === true || query.data?.isAdmin === true,
  };
}
